module.exports = __webpack_public_path__ + "media/Scales-to-infinity-Gif.a3f6224f.mp4";